module.exports = __webpack_public_path__ + "media/images/360/circadian_rhytm_mimosa_pudica-5c7c68a181165e5f7ca1eccd100b6c04.webp";